import { $api } from '@shared/api';
import { routes } from '@shared/api/routes';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

import { IFinanceExportReport } from '../model/types';

export const getFinanceExportReportsFunc = ({ signal }: { signal?: AbortSignal }) =>
    $api.get<IDataResponse<IFinanceExportReport[]>>(routes.companyFinanceExportRequestsList(), {
        signal,
    });

export const deleteFinanceExportReportFunc = (id: number) =>
    $api.delete(
        routes.financeExportRequestDelete({
            _requestId_: id,
        })
    );

export const retryFinanceExportReportFunc = (id: number) =>
    $api.post(routes.financeExportRequestRetry({ _requestId_: id }));

export const financeExportRequestsCheckStatusFunc = (ids: number[]) => {
    const formData = new FormData();

    ids.forEach((id) => {
        formData.append('ids[]', `${id}`);
    });

    return $api.post<IDataResponse<IFinanceExportReport[]>>(
        routes.financeExportRequestsCheckStatus(),
        formData
    );
};
